import React from 'react';
import styled from '../../styles/styled-components';
import { Paper } from '../paper';

export type PageContentProps = { header?: string } & Stylable;

export const PageContent: React.FC<PageContentProps> = ({
  children,
  header,
  ...rest
}) => (
  <Container {...rest}>
    <ContentPaper>
      {!!header && <PageContentHeader>{header}</PageContentHeader>}
      {children}
    </ContentPaper>
  </Container>
);

export const PageContentHeader = styled.h3`
  width: calc(100% + 40px);
  border-bottom: 1px solid ${p => p.theme.dividerColor};
  margin-left: -20px;
  padding-left: 20px;
  margin-top: -5px;
  padding-bottom: 14px;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 500;
`;

const Container = styled.div`
  width: 100%;
  min-height: 100%;
  padding: 20px 0;
  // overflow: auto;
`;
const ContentPaper = styled(Paper)`
  width: 100%;
  height: 100%;
  min-height: 200px;
`;
